var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var SurveyEntryMyGi = require('./surveyEntryMyGi.jsx');

var DashboardWithoutDataMyGi = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return (
            <div className={'dashboard-without-data' + (this.props.isEmpty ? ' is-empty' : '')}>
                <div className="content-header-wrapper">
                    <div className="content-header-small content-header row column">
                        <h1>MyGi</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="large-6 column">
                        <div className="half-bg"></div>
                    </div>
                    <div className="large-6 column end">
                        <div className="hero-text-block">
                            <h2>Have Symptoms? Let’s <br />Track them now</h2>
                            <p>You currently do not have any new symptoms reported</p>
                            <p>
                                <SurveyEntryMyGi
                                    className="success"
                                    labelText="Take Symptom Tracker Survey"
                                    daysBeforeLatestSurvey={this.props.daysBeforeLatestSurvey}
                                    showModal={this.props.showModal}
                                    clickTracking={this.props.clickTracking} />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = DashboardWithoutDataMyGi;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardWithoutDataMyGi.jsx